import React, { useState } from 'react';
import ctl from '@netlify/classnames-template-literals';
import LoadingComponent from 'components/shared/LoadingComponent';
const Button = ({ id, variant = 'primary', children, style, disabled = false, isLoading = false, onClick, customClass, onMouseEnter, onMouseLeave, stopPropagation = true, key, alignText = 'center', usePadding = true, onMouseDown, enableClickEvent = true, useMinHeight = true, useRounded = true, backgroundClass = 'bg-transparent', type = 'button' }) => {
    const isDisabled = disabled || isLoading;
    const getVariantClassName = () => {
        if (variant === 'custom')
            return '';
        return ctl(`
      cursor-pointer
      typography-button
      ${variant === 'primary' &&
            `
          ${usePadding && 'px-[16px]'}
          border-0
          bg-base-600
          text-n-100
          hover:bg-base-500 active:bg-base-500
        `}

      ${variant === 'secondary' &&
            alignText !== 'left' &&
            `
          ${usePadding && 'px-[16px]'}
          border
          border-solid
          border-n-400 bg-n-000 text-n-900
        `}

      ${variant === 'secondary' &&
            alignText === 'left' &&
            `
          border-0
          ${backgroundClass}
        `}

      ${variant === 'tertiary' &&
            !isDisabled &&
            `
          border-0
          ${backgroundClass}
          text-base-600
          ${usePadding && 'px-[8px]'}
        `}

      ${variant === 'danger' &&
            !isDisabled &&
            `
          border-0
          bg-r-600
          px-[16px]
          text-n-100
        `}
      ${(variant === 'secondary' || variant == 'tertiary') &&
            !isDisabled &&
            `hover:bg-base-30024 active:bg-base-30024`}
    `);
    };
    const btnCN = ctl(`
    flex

    ${alignText === 'left' && `justify-start`}
    ${alignText === 'right' && `justify-end`}
    ${alignText === 'center' && `justify-center`}
    ${useMinHeight && 'min-h-[32px]'}
    ${useRounded && 'rounded-[4px]'}

    items-center
    whitespace-nowrap
    leading-[16px]

    ${!isDisabled
        ? getVariantClassName()
        : `disabled cursor-not-allowed border-0 ${variant === 'tertiary' ? 'bg-transparent px-[8px]' : 'bg-n-300 px-[16px]'} text-n-600`}

    ${customClass}
  `);
    let onEnterProps = {};
    if (onMouseEnter && onMouseLeave) {
        onEnterProps = {
            onMouseEnter,
            onMouseLeave
        };
    }
    const handleClick = (e) => {
        if (!enableClickEvent)
            return;
        stopPropagation && e.stopPropagation();
        onClick && onClick(e);
    };
    const handleMouseDown = (e) => {
        if (!enableClickEvent || !onMouseDown)
            return;
        stopPropagation && e.stopPropagation();
        onMouseDown(e);
    };
    return (React.createElement("button", { id: id, key: key || id, className: btnCN, style: { ...style, outline: 'none' }, onClick: (e) => handleClick(e), onMouseDown: handleMouseDown, disabled: isDisabled, "data-cy": id, type: type, ...onEnterProps },
        isLoading && (React.createElement(LoadingComponent, { hasText: false, size: 20, className: "mr-[4px] py-[0px]" })),
        children));
};
const Secondary = (props) => {
    return React.createElement(Button, { variant: "secondary", ...props });
};
const Tertiary = (props) => {
    return React.createElement(Button, { variant: "tertiary", ...props });
};
const Submit = (props) => {
    const [localDisabled, setLocalDisabled] = useState(false);
    const disabled = localDisabled || props.disabled || false;
    const handleClick = async () => {
        setLocalDisabled(true);
        props.onClick && (await props.onClick());
        setLocalDisabled(false);
    };
    return (React.createElement(Button, { ...props, variant: "primary", onClick: handleClick, disabled: disabled }));
};
Button.Secondary = Secondary;
Button.Tertiary = Tertiary;
Button.Submit = Submit;
export default Button;
